import { defineStore } from "pinia";
import { $t } from "@/i18n";
import { useDefaultStore } from "@/store";

import cover1 from "@/assets/image/references/covers/solarni-paneli-na-zemlji.png";

import galleryLogo from "@/assets/image/logo-800.png";

import ref1_1 from "@/assets/image/references/gallery/ref1-1.jpg";
import ref1_2 from "@/assets/image/references/gallery/ref1-2.jpg";
import ref2_1 from "@/assets/image/references/gallery/ref2-1.jpg";
import ref3_1 from "@/assets/image/references/gallery/ref3-1.jpg";
import ref3_2 from "@/assets/image/references/gallery/ref3-2.jpg";
import ref3_3 from "@/assets/image/references/gallery/ref3-3.jpg";
import ref3_4 from "@/assets/image/references/gallery/ref3-4.jpg";
import ref4_1 from "@/assets/image/references/gallery/ref4-1.jpg";
import ref4_2 from "@/assets/image/references/gallery/ref4-2.jpg";
import ref4_3 from "@/assets/image/references/gallery/ref4-3.jpg";
import ref5_1 from "@/assets/image/references/gallery/ref5-1.jpg";
import ref5_2 from "@/assets/image/references/gallery/ref5-2.jpg";
import ref7_1 from "@/assets/image/references/gallery/solarna-elektrana-kompanije-izbor-arilje-20-kwp.jpg";
import ref8_1 from "@/assets/image/references/gallery/ref8-1.jpg";
import ref9_1 from "@/assets/image/references/gallery/ref9-1.png";
import ref9_2 from "@/assets/image/references/gallery/solarna-elektrana-apatinska-pivara-100-kwp.png";
import ref9_3 from "@/assets/image/references/gallery/ref9-3.jpg";
import ref10_1 from "@/assets/image/references/gallery/ref10-1.jpg";
import ref10_2 from "@/assets/image/references/gallery/ref10-2.jpg";
import ref10_3 from "@/assets/image/references/gallery/ref10-3.jpg";
import ref11_1 from "@/assets/image/references/gallery/ref11-1.jpg";
import ref11_2 from "@/assets/image/references/gallery/ref11-2.jpg";
import ref11_3 from "@/assets/image/references/gallery/ref11-3.jpg";
import ref11_4 from "@/assets/image/references/gallery/ref11-4.jpg";
import ref12_1 from "@/assets/image/references/gallery/ref12-1.jpg";
import ref12_2 from "@/assets/image/references/gallery/ref12-2.jpg";
import ref12_3 from "@/assets/image/references/gallery/ref12-3.jpg";
import ref12_4 from "@/assets/image/references/gallery/ref12-4.jpg";
import ref13_1 from "@/assets/image/references/gallery/solarna-elektrana-na-krovu-extra-tropic-trade-nova-pazova-60-kwp.png";
import ref13_2 from "@/assets/image/references/gallery/ref13-2.jpg";
import ref13_3 from "@/assets/image/references/gallery/ref13-3.jpg";
import ref14_1 from "@/assets/image/references/gallery/ref14-1.jpg";
import ref14_2 from "@/assets/image/references/gallery/ref14-2.jpg";
import ref14_3 from "@/assets/image/references/gallery/ref14-3.jpg";
import ref15_1 from "@/assets/image/references/gallery/ref15-1.jpg";
import ref15_2 from "@/assets/image/references/gallery/ref15-2.jpg";
import ref16_1 from "@/assets/image/references/gallery/ref16-1.jpg";
import ref16_2 from "@/assets/image/references/gallery/ref16-2.jpg";
import ref16_3 from "@/assets/image/references/gallery/ref16-3.jpg";
import ref16_4 from "@/assets/image/references/gallery/ref16-4.jpg";
import ref16_5 from "@/assets/image/references/gallery/ref16-5.jpg";
import ref17_1 from "@/assets/image/references/gallery/ref17-1.jpg";
import ref17_2 from "@/assets/image/references/gallery/ref17-2.jpg";
import ref17_3 from "@/assets/image/references/gallery/ref17-3.jpg";
import ref18_1 from "@/assets/image/references/gallery/ref18-1.jpg";
import ref18_2 from "@/assets/image/references/gallery/ref18-2.jpg";
import ref18_3 from "@/assets/image/references/gallery/ref18-3.jpg";
import ref19_1 from "@/assets/image/references/gallery/ref19-1.jpg";
import ref19_2 from "@/assets/image/references/gallery/ref19-2.jpg";
import ref19_3 from "@/assets/image/references/gallery/ref19-3.jpg";
import ref19_4 from "@/assets/image/references/gallery/ref19-4.jpg";
import ref20_1 from "@/assets/image/references/gallery/ref20-1.jpg";
import ref20_2 from "@/assets/image/references/gallery/ref20-2.jpg";
import ref21_1 from "@/assets/image/references/gallery/ref21-1.jpg";
import ref21_2 from "@/assets/image/references/gallery/ref21-2.jpg";
import ref21_3 from "@/assets/image/references/gallery/ref21-3.jpg";
import ref22_1 from "@/assets/image/references/gallery/ref22-1.jpg";
import ref22_2 from "@/assets/image/references/gallery/ref22-2.jpg";
import ref22_3 from "@/assets/image/references/gallery/ref22-3.jpg";
import ref23_1 from "@/assets/image/references/gallery/ref23-1.jpg";
import ref23_2 from "@/assets/image/references/gallery/ref23-2.jpg";
import ref23_3 from "@/assets/image/references/gallery/ref23-3.jpg";
import ref24_1 from "@/assets/image/references/gallery/solarna-elektrana-na-krovu-tomovic-parketi-cacak-firme-130-kwp.jpg";
import ref25_1 from "@/assets/image/references/gallery/ref25-1.jpg";
import ref25_2 from "@/assets/image/references/gallery/ref25-2.jpg";
import ref25_3 from "@/assets/image/references/gallery/ref25-3.jpg";
import ref25_4 from "@/assets/image/references/gallery/ref25-4.jpg";
import ref25_5 from "@/assets/image/references/gallery/ref25-5.jpg";
import ref26_1 from "@/assets/image/references/gallery/ref26-1.jpg";
import ref26_2 from "@/assets/image/references/gallery/ref26-2.jpg";
import ref26_3 from "@/assets/image/references/gallery/ref26-3.jpg";
import ref27_1 from "@/assets/image/references/gallery/ref27-1.jpg";
import ref27_2 from "@/assets/image/references/gallery/solarna-elektrana-na-krovu-belanova-vladicin-han-189-kwp.png";
import ref28_1 from "@/assets/image/references/gallery/ref28-1.jpg";
import ref28_2 from "@/assets/image/references/gallery/ref28-2.jpg";
import ref28_3 from "@/assets/image/references/gallery/ref28-3.jpg";
import ref29_1 from "@/assets/image/references/gallery/solarna-kutija-za-168-kwp-sistem-za-budimgrad-kompaniju.png";
import ref29_2 from "@/assets/image/references/gallery/solarni-inverter-solarna-elektrana-budimgrad-168-kwp.png";
import ref29_3 from "@/assets/image/references/gallery/solarna-elektrana-na-krovu-firme-budimgrad-168-kwp.png";
import ref30_1 from "@/assets/image/references/gallery/ref30-1.jpg";
import ref30_2 from "@/assets/image/references/gallery/ref30-2.jpg";
import ref30_3 from "@/assets/image/references/gallery/ref30-3.jpg";
import ref31_1 from "@/assets/image/references/gallery/ref31-1.jpg";
import ref31_2 from "@/assets/image/references/gallery/ref31-2.jpg";
import ref31_3 from "@/assets/image/references/gallery/ref31-3.jpg";
import ref31_4 from "@/assets/image/references/gallery/ref31-4.jpg";
import ref31_5 from "@/assets/image/references/gallery/ref31-5.jpg";
import ref32_1 from "@/assets/image/references/gallery/ref32-1.jpg";
import ref32_2 from "@/assets/image/references/gallery/ref32-2.jpg";
import ref32_3 from "@/assets/image/references/gallery/ref32-3.jpg";
import ref32_4 from "@/assets/image/references/gallery/ref32-4.jpg";
import ref32_5 from "@/assets/image/references/gallery/ref32-5.jpg";
import ref33_1 from "@/assets/image/references/gallery/ref33-1.jpg";
import ref33_2 from "@/assets/image/references/gallery/ref33-2.jpg";
import ref33_3 from "@/assets/image/references/gallery/ref33-3.jpg";
import ref33_4 from "@/assets/image/references/gallery/ref33-4.jpg";
import ref34_1 from "@/assets/image/references/gallery/ref34-1.jpg";
import ref34_2 from "@/assets/image/references/gallery/ref34-2.jpg";
import ref35_1 from "@/assets/image/references/gallery/ref35-1.jpg";
import ref35_2 from "@/assets/image/references/gallery/ref35-2.jpg";
import ref35_3 from "@/assets/image/references/gallery/ref35-3.jpg";
import ref36_1 from "@/assets/image/references/gallery/ref36-1.jpg";
import ref36_2 from "@/assets/image/references/gallery/ref36-2.jpg";
import ref37_1 from "@/assets/image/references/gallery/ref37-1.jpg";
import ref38_1 from "@/assets/image/references/gallery/ref38-1.jpg";
import ref38_2 from "@/assets/image/references/gallery/ref38-2.jpg";
import ref38_3 from "@/assets/image/references/gallery/ref38-3.jpg";
import ref39_1 from "@/assets/image/references/gallery/ref39-1.jpg";
import ref39_2 from "@/assets/image/references/gallery/ref39-2.jpg";
import ref40_1 from "@/assets/image/references/gallery/ref40-1.jpg";
import ref40_2 from "@/assets/image/references/gallery/ref40-2.jpg";
import ref41_1 from "@/assets/image/references/gallery/ref41-1.jpg";
import ref42_1 from "@/assets/image/references/gallery/ref42-1.jpg";
import ref42_2 from "@/assets/image/references/gallery/ref42-2.jpg";
import ref43_1 from "@/assets/image/references/gallery/ref43-1.jpg";
import ref43_2 from "@/assets/image/references/gallery/ref43-2.jpg";
import ref44_1 from "@/assets/image/references/gallery/ref44-1.jpg";
import ref45_1 from "@/assets/image/references/gallery/ref45-1.jpg";
import ref46_1 from "@/assets/image/references/gallery/ref46-1.jpg";
import ref46_2 from "@/assets/image/references/gallery/ref46-2.jpg";
import ref47_1 from "@/assets/image/references/gallery/ref47-1.jpg";
import ref47_2 from "@/assets/image/references/gallery/ref47-2.jpg";
import ref54_1 from "@/assets/image/references/gallery/ref54-1.jpg";
import ref54_2 from "@/assets/image/references/gallery/ref54-2.jpg";
import ref55_1 from "@/assets/image/references/gallery/ref55-1.jpg";
import ref55_2 from "@/assets/image/references/gallery/ref55-2.jpg";
import ref56_1 from "@/assets/image/references/gallery/ref56-1.jpg";
import ref56_2 from "@/assets/image/references/gallery/ref56-2.jpg";
import ref57_1 from "@/assets/image/references/gallery/ref57-1.jpg";

import ref53_1 from "@/assets/image/references/gallery/ref53-1.png";
import ref53_2 from "@/assets/image/references/gallery/solarna-elektrana-apatinska-pivara-100-kwp.png";
import ref53_3 from "@/assets/image/references/gallery/ref53-3.jpg";
import ref52_1 from "@/assets/image/references/gallery/ref52-1.jpg";
import ref52_2 from "@/assets/image/references/gallery/ref52-2.jpg";
import ref52_3 from "@/assets/image/references/gallery/ref52-3.jpg";
import ref51_1 from "@/assets/image/references/gallery/ref51-1.jpg";
import ref51_2 from "@/assets/image/references/gallery/ref51-2.jpg";
import ref50_1 from "@/assets/image/references/gallery/ref50-1.jpg";
import ref49_1 from "@/assets/image/references/gallery/ref49-1.jpg";
import ref49_2 from "@/assets/image/references/gallery/ref49-2.jpg";
import ref48_1 from "@/assets/image/references/gallery/ref48-1.jpg";
import ref48_2 from "@/assets/image/references/gallery/ref48-2.jpg";
import ref48_3 from "@/assets/image/references/gallery/ref48-3.jpg";

import ref58_1 from "@/assets/image/references/gallery/ref58-1.jpg";
import ref58_2 from "@/assets/image/references/gallery/ref58-2.jpg";
import ref58_3 from "@/assets/image/references/gallery/ref58-3.jpg";
import ref59_1 from "@/assets/image/references/gallery/ref59-1.jpg";
import ref59_2 from "@/assets/image/references/gallery/ref59-2.jpg";
import ref60_1 from "@/assets/image/references/gallery/ref60-1.jpg";
import ref60_2 from "@/assets/image/references/gallery/ref60-2.jpg";

import testimonial_1 from "@/assets/image/legalTestimonials/legal-testimonial-6.jpg";
import testimonial_2 from "@/assets/image/legalTestimonials/legal-testimonial-1.png";
import testimonial_3 from "@/assets/image/legalTestimonials/legal-testimonial-2.png";
import testimonial_4 from "@/assets/image/legalTestimonials/legal-testimonial-3.png";
import testimonial_5 from "@/assets/image/legalTestimonials/legal-testimonial-4.png";
import testimonial_6 from "@/assets/image/legalTestimonials/solarni-paneli-na-kuci.png";

const store = useDefaultStore();

export const useReferencesStore = defineStore("references", () => {
	const referencesList = [
		{
			id: 1,
			path: "blog",
			blt_id: 1,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb1.png`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Belmil D.O.O. 150 KWP",
			titleTop: "150kWp - BELMIL",
			location: "Ada",
			solar_panels: "Luxor 370 Wp",
			inverters: "Huawei",
			system_power: "150kWp",
			batteries: "",
			solar_panels_number: 397,
			inverters_number: 2,
			description: `Za Belmil DOO iz Ade smo izgradili solarnu elektranu sa 150 kWp snažnim sistemom, Luxor 370 Wp solarnim panelima i Huawei inverterima! Saznajte više!`,
			expected_production: 180_000,
			gallery: [ref1_1, ref1_2],
			slug: "Solarna-elektrana-150-kWp-Belmil",
			content: ``,
		},
		{
			id: 2,
			path: "blog",
			blt_id: 1,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb2.jpg`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Fush D.O.O Beograd 100 KWP",
			titleTop: "100 kWp - FUSH",
			location: "Beograd",
			solar_panels: "Luxor 370 Wp",
			inverters: "Huawei",
			system_power: "100 kWp",
			batteries: "",
			solar_panels_number: 297,
			inverters_number: 2,
			description: `Za Fush DOO iz Beograda smo izgradili solarnu elektranu sa 100 kWp snažnim sistemom, Luxor 370 Wp solarnim panelima i Huawei inverterima. Saznajte više!`,
			expected_production: 120_000,
			gallery: [ref2_1],
			slug: `Solarna-elektrana-Fush D.o.o-100 kWp`,
			content: "",
		},
		{
			id: 3,
			path: "blog",
			blt_id: 1,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumb-logo.png`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Badotextile D.O.O 200 KWP",
			titleTop: "200 kWp - BADOTEXTILE",
			location: "Topola",
			solar_panels: "Luxor 370 Wp",
			inverters: "Huawei",
			system_power: "200 kWp",
			batteries: "",
			solar_panels_number: 540,
			inverters_number: 3,
			description: `Za Badotextile DOO iz Topole smo izgradili solarnu elektranu sa 200kWP snažnim sistemom, Luxor 370Wp solarnim panelima i Hauwei inverterima! Saznajte više!`,
			expected_production: 240_000,
			gallery: [ref3_1, ref3_2, ref3_3, ref3_4],
			slug: `solarna-elektrana-od-200kwp-badotextile-doo`,
			content: "",
		},
		{
			id: 4,
			path: "blog",
			blt_id: 1,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb4.jpg`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Jasmil D.O.O. 50 KWP",
			titleTop: "50 kWp - JASMIL",
			location: "Arilje",
			solar_panels: "Luxor 450 Wp",
			inverters: "Huawei",
			system_power: "50 kWp",
			batteries: "",
			solar_panels_number: 112,
			inverters_number: 1,
			description: `Za Jasmil DOO iz Arilja smo izgradili solarnu elektranu sa 50 kWp snažnim sistemom, LUxor 450 Wp solanima panelima i Huawei inverterima! Saznajte više!`,
			expected_production: 60_000,
			gallery: [ref4_1, ref4_2, ref4_3],
			slug: "solarna-elektrana-od-50kwp-jasmil-doo",
			content: "",
		},
		{
			id: 5,
			path: "blog",
			blt_id: 1,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumb-logo.png`,
			cover: cover1,
			pageTitle: "Solarna Elektrana DN Company 200 KWP",
			titleTop: "200 kWp - DN COMPANY",
			location: "Vladičin Han",
			solar_panels: "Luxor 370 Wp",
			inverters: "Huawei",
			system_power: "",
			batteries: "",
			solar_panels_number: 540,
			inverters_number: 3,
			description: `Za kompaniju DN Company iz Vladičinog Hana smo izgradili solarnu elektranu sa 200 kWp snažnim sistemom i Luxor 370 Wp solarnim panelima! Saznajte više!`,
			expected_production: 240_000,
			gallery: [ref5_1, ref5_2],
			slug: "solarna-elektrana-200-kwp-dn-company-vladicin-han",
			content: "",
		},
		{
			id: 6,
			path: "blog",
			blt_id: 1,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb6.png`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Feniks D.O.O. 160 KWP",
			titleTop: "160 kWp - NIZ FENIKS",
			location: "Čačak",
			solar_panels: "Luxor 370 Wp",
			inverters: "Huawei",
			system_power: "",
			batteries: "",
			solar_panels_number: 432,
			inverters_number: 3,
			description: `Za Feniks DOO iz Čačka smo izgradili solarnu elektranu sa 160 kWp snažnim sistemom, Luxor 370 Wp solarnim panelima i Huawei inverterima! Saznajte više!`,
			expected_production: 192_000,
			gallery: [galleryLogo],
			slug: "solarna-elektrana-160-kwp-feniks-cacak",
			content: "",
		},
		{
			id: 7,
			path: "blog",
			blt_id: 1,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb7.png`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Izbor D.O.O 20 KWP",
			titleTop: "20 kWp - IZBOR",
			location: "Arilje",
			solar_panels: "Luxor 370 Wp",
			inverters: "Huawei",
			system_power: "",
			batteries: "",
			solar_panels_number: 378,
			inverters_number: 2,
			description: `Za Izbor DOO iz Arilja smo izgradili solarnu elektranu sa 20 kWp snažnim sistemom, Luxor 370 Wp solarnim panelima i Huawei inverterima! Saznajte više!`,
			expected_production: 24_000,
			gallery: [ref7_1],
			slug: "solarna-elektrana-snage-20-kwp",
			content: "",
		},
		{
			id: 9,
			path: "blog",
			blt_id: 1,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb48.png`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Apa D.O.O. 100 KWP",
			titleTop: "100 kWp - APATINSKA PIVARA",
			location: "Apatin",
			solar_panels: "Luxor 540Wp",
			inverters: "Huawei",
			system_power: "100 kWp",
			batteries: "",
			solar_panels_number: 183,
			inverters_number: 1,
			description: `Za Apa DOO iz Apatina smo izgradili solarnu elektranu sa 100 kWp snažnim sistemom, Luxor 540 Wp solarnim panelima i Huawei inverterima! Saznajte više!`,
			expected_production: 120_000,
			gallery: [ref9_1, ref9_2, ref9_3],
			slug: "solarna-elektrana-od-100kWp",
			content: "",
		},
		{
			id: 10,
			path: "blog",
			blt_id: 1,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb8.png`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Moka Čačak D.O.O 100 KWP",
			titleTop: "100 kWp - MOKA ČAČAK",
			location: "Čačak",
			solar_panels: "Solar Fabrik 340 Wp",
			inverters: "Huawei",
			system_power: "100 kWp",
			batteries: "",
			solar_panels_number: 294,
			inverters_number: 2,
			description: `Za Moka DOO iz Čačka smo izgradili solarnu elektranu sa 100 kWp snažnim sistemom, Solar Fabrik 340Wp solarnim panelima i Hauwei inverterima! Saznajte više!`,
			expected_production: 120_000,
			gallery: [ref10_1, ref10_2, ref10_3],
			slug: "Solarna-elektrana-100-kwp",
			content: "",
		},
		{
			id: 11,
			path: "blog",
			blt_id: 1,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb11.svg`,
			cover: cover1,
			pageTitle: "Solarna Elektrana RSV Trgovina Arilje 200 KWP",
			titleTop: "200 kWp - RSV TRGOVINA",
			location: "Arilje",
			solar_panels: "Luxor 370 Wp",
			inverters: "Huawei",
			system_power: "200 kWp",
			batteries: "",
			solar_panels_number: 540,
			inverters_number: 3,
			description: `Za RSV Trgovina iz Arilja smo izgradili solarnu elektranu sa 200 kWp snažnim sistemom, Luxor 370 Wp solarnim panelima i Huawei inverterima. Saznajte više!`,
			expected_production: 240_000,
			gallery: [ref11_1, ref11_2, ref11_3, ref11_4],
			slug: "rsv-trgovina-arilje-200kwp",
			content: "",
		},
		{
			id: 13,
			path: "blog",
			blt_id: 1,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb13.png`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Extra Tropic Trade DOO 60 KWP",
			titleTop: "60 kWp - EXTRA TROPIC TRADE",
			location: "Nova Pazova",
			solar_panels: "Luxor 410 Wp",
			inverters: "Huawei",
			system_power: "60 kWp",
			batteries: "",
			solar_panels_number: 144,
			inverters_number: 1,
			description: `Za Extra Tropic Trade DOO iz Nove Pazove smo izgradili solarnu elektranu sa 60 kWp snažnim sistemom, Luxor 410 Wp solarnim panelima i Huawei inverterima!`,
			expected_production: 72_000,
			gallery: [ref13_1, ref13_2, ref13_3],
			slug: "solarna-elektrana-od-60kWp",
			content: "",
		},
		{
			id: 15,
			path: "blog",
			blt_id: 1,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb8.png`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Moka Čačak D.O.O. 315 KWP",
			titleTop: "315 kWp - MOKA ČAČAK",
			location: "Čačak",
			solar_panels: "Solar Fabrik 340 Wp",
			inverters: "Huawei",
			system_power: "315 kWp",
			batteries: "",
			solar_panels_number: 924,
			inverters_number: 5,
			description: `Za Moka DOO iz Čačka smo izgradili solarnu elektranu sa 315 kWp sistemom, Solar Fabrik 340 Wp solarnim panelima i Huawei inverterima! Saznajte više!`,
			expected_production: 378_000,
			gallery: [ref15_1, ref15_2],
			slug: "Solarna-elektrana-315kwp-Cacak",
			content: "",
		},
		{
			id: 16,
			path: "blog",
			blt_id: 1,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb16.png`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Animal Commerce D.O.O. 200 KWP",
			titleTop: "200 kWp - ANIMAL COMMERCE",
			location: "Beograd",
			solar_panels: "Luxor 370 Wp",
			inverters: "Huawei",
			system_power: "200 kWp",
			batteries: "",
			solar_panels_number: 540,
			inverters_number: 3,
			description: `Za Animal Commerce DOO iz Beograda smo izgradili solarnu elektranu sa 200 kWp snažnim sistemom, Luxor 370 Wp solarnim panelima i Huawei inverterima!`,
			expected_production: 240_000,
			gallery: [ref16_1, ref16_2, ref16_3, ref16_4, ref16_5],
			slug: "solarna-elektrana-od-200kwp-animal-commerce-doo",
			content: "",
		},
		{
			id: 17,
			path: "blog",
			blt_id: 1,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb17.png`,
			cover: cover1,
			pageTitle: "Solarna Elektrana za Vasović D.O.O. 185 KWP",
			titleTop: "185 kWp - VASOVIĆ",
			location: "Čačak/Beograd",
			solar_panels: "Luxor 355 Wp",
			inverters: "Huawei",
			system_power: "185 kWp",
			batteries: "",
			solar_panels_number: 337,
			inverters_number: 22,
			description: `Za Vasović DOO iz Čačka smo montirali solarnu elektranu sa 185 kWp snažnim sistemom, Luxor 355 Wp solarnim panelima i Huawei inverterima. Saznajte više!`,
			expected_production: 222_000,
			gallery: [ref17_1, ref17_2, ref17_3],
			slug: "solarna-elektrana-od-185kWp",
			content: "",
		},
		{
			id: 18,
			path: "blog",
			blt_id: 1,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb18.png`,
			cover: cover1,
			pageTitle: "Solarna Elektrana ICM D.O.O. 42 KWP",
			titleTop: "42 kWp - ICM",
			location: "Novi Sad",
			solar_panels: "Luxor 410 Wp",
			inverters: "Huawei",
			system_power: "42 kWp",
			batteries: "",
			solar_panels_number: 94,
			inverters_number: 1,
			description: `Za ICM DOO iz Novog Sada smo izgradili solarnu elektranu sa 42 kWp snažnim sistemom, Luxor 410 Wp solarnim panelima i Huawei inverterima! Saznajte više!`,
			expected_production: 50_400,
			gallery: [ref18_1, ref18_2, ref18_3],
			slug: "solarna-elektrana-od-42kWp",
			content: "",
		},
		{
			id: 20,
			path: "blog",
			blt_id: 1,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb20.png`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Attrium Čačak D.O.O. 200 KWP",
			titleTop: "200 kWp - ATTRIUM ČAČAK",
			location: "Čačak",
			solar_panels: "Luxor 370 Wp",
			inverters: "Huawei",
			system_power: "200 kWp",
			batteries: "",
			solar_panels_number: 540,
			inverters_number: 3,
			description: `Za Attrium DOO iz Čačka smo izgradili solarnu elektranu sa 200 kWp snažnim sistemom, Luxor 370 Wp solarnim panelima i Huawei inverterima! Saznajte više!`,
			expected_production: 240_000,
			gallery: [ref20_1, ref20_2],
			slug: "solarna-elektrana-200-kwp-attrium-cacak-doo",
			content: "",
		},
		{
			id: 21,
			path: "blog",
			blt_id: 1,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb21.png`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Lumberline Apatin 180 KWP",
			titleTop: "180 kWp - LUMBERLINE",
			location: "Apatin",
			solar_panels: "Luxor 455 Wp",
			inverters: "Huawei",
			system_power: "180 kWp",
			batteries: "",
			solar_panels_number: 396,
			inverters_number: 4,
			description: `Za Lumberline iz Apatina smo izgradili solarnu elektranu sa 180 kWp snažnim sistemom, Luxor 455 Wp solarnim panelima i Huawei inverterima. Saznajte više!`,
			expected_production: 216_000,
			gallery: [ref21_1, ref21_2, ref21_3],
			slug: "solarna-elektrana-od-180kWp",
			content: "",
		},
		{
			id: 22,
			path: "blog",
			blt_id: 1,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb22.png`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Gazela Komerc Sombor 60 KWP",
			titleTop: "60 kWp - GAZELA KOMERC",
			location: "Sombor",
			solar_panels: "",
			inverters: "Huawei",
			system_power: "60 kWp",
			batteries: "",
			solar_panels_number: 147,
			inverters_number: 1,
			description: `Za Gazela Komerc Sombor smo izgradili solarnu elektranu sa 60 kWp snažnim sistemom i Huawei solarnim inverterima. Saznajte više o ovom solarnom sistemu!`,
			expected_production: 72_000,
			gallery: [ref22_1, ref22_2, ref22_3],
			slug: "solarna-elektrana-od-60kwp-gazela-komerc",
			content: "",
		},
		{
			id: 24,
			path: "blog",
			blt_id: 1,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb24.png`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Tomović Parketi D.O.O. 130 KWP",
			titleTop: "130 kWp - TOMOVIĆ PARKETI",
			location: "Čačak",
			solar_panels: "Luxor 370 Wp",
			inverters: "Huawei",
			system_power: "130 kWp",
			batteries: "",
			solar_panels_number: 351,
			inverters_number: 2,
			description: `Za Tomović Parketi DOO iz Čačka smo izgradili solarnu elektranu sa 130 kWp sistemom, Luxor 370 Wp solarnim panelima i Huawei inverterima! Saznajte više!`,
			expected_production: 156_000,
			gallery: [ref24_1],
			slug: "Solarna-elektrana-130-kWp-Tomovic-Parketi-D.o.o",
			content: "",
		},
		{
			id: 25,
			path: "blog",
			blt_id: 1,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb25.png`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Arteks D.O.O. 144 KWP",
			titleTop: "144 kWp - ARTEKS",
			location: "Arilje",
			solar_panels: "Luxor 450 Wp",
			inverters: "Huawei",
			system_power: "144 kWp",
			batteries: "",
			solar_panels_number: 510,
			inverters_number: 2,
			description: `Za Arteks DOO iz Arilja smo izgradili solarnu elektranu sa 144 kWp snažnim sistemom, Luxor 450 Wp solarnim panelima i Huawei inverterima! Saznajte više!`,
			expected_production: 172_800,
			gallery: [ref25_1, ref25_2, ref25_3, ref25_4, ref25_5],
			slug: "solarna-elektrana-od-144kWp",
			content: "",
		},
		{
			id: 26,
			path: "blog",
			blt_id: 1,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumb-logo.png`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Mićić DOO 50 KWP",
			titleTop: "50 kWp - MICIĆ",
			location: "Arilje",
			solar_panels: "Luxor 450 Wp",
			inverters: "Huawei",
			system_power: "50 kWp",
			batteries: "",
			solar_panels_number: 112,
			inverters_number: 1,
			description: `Za Mićić-M DOO iz Arilja smo izgradili solarnu elektranu sa 50 kWp snažnim sistemom, Luxor 450 Wp solarnim panelima i Huawei inverterima! Saznajte više!`,
			expected_production: 60_000,
			gallery: [ref26_1, ref26_2, ref26_3],
			slug: "micic-50kwp-arilje",
			content: "",
		},
		{
			id: 27,
			path: "blog",
			blt_id: 1,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumb-logo.png`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Belanova Vladičin Han 189 KWP",
			titleTop: "189 kWp - BELANOVA",
			location: "Vladičin Han",
			solar_panels: "",
			inverters: "Huawei",
			system_power: "189 kWp",
			batteries: "",
			solar_panels_number: 510,
			inverters_number: 3,
			description: `Za kompaniju Belanova iz Vladičinog Hana smo izgradili solarnu elektranu sa 189 kWp snažnim sistemom i Huawei inverterima. Saznajte više o ovom sistemu!`,
			expected_production: 226_800,
			gallery: [ref27_1, ref27_2],
			slug: "solarna-elektrana-od-189kwp-belanova",
			content: "",
		},
		{
			id: 28,
			path: "blog",
			blt_id: 1,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb12.png`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Rudnik D.O.O. Gornji Milanovac",
			titleTop: "95 kWp - RUDNIK",
			location: "Gornji Milanovac",
			solar_panels: "Luxor 410 Wp",
			inverters: "Huawei",
			system_power: "95 kWp",
			batteries: "",
			solar_panels_number: 231,
			inverters_number: 2,
			description: `Za Rudnik DOO iz Gornjeg Milanovca smo izgradili solarnu elektranu sa 95 kWp snažnim sistemom, Luxor 410 Wp solarnim panelima i Huawei inverterima!`,
			expected_production: 114_000,
			gallery: [ref28_1, ref28_2, ref28_3],
			slug: "solarna-elektrana-od-95kwp-rudnik-doo",
			content: "",
		},
		{
			id: 29,
			path: "blog",
			blt_id: 1,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumb-logo.png`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Budimgrad 168KWP",
			titleTop: "168 kWp - BUDIMGRAD",
			location: "Budilovina",
			solar_panels: "Luxor 410 Wp",
			inverters: "Huawei",
			system_power: "168 kWp",
			batteries: "",
			solar_panels_number: 409,
			inverters_number: 3,
			description: `Treba vam solarna elektrana na lokaciji Budilovina? Pogledajte solarnu elektranu od 168 kWp sa Luxor 410 Wp solarnim panelima koju smo tamo montirali!`,
			expected_production: 201_600,
			gallery: [ref29_1, ref29_2, ref29_3],
			slug: "solarna-elektrana-od-168kWp",
			content: "",
		},
		{
			id: 30,
			path: "blog",
			blt_id: 1,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb30.png`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Eko Pak 190 KWP",
			titleTop: "190 kWp - EKO PAK",
			location: "Surdulica",
			solar_panels: "Luxor 410 Wp",
			inverters: "Huawei",
			system_power: "190 kWp",
			batteries: "",
			solar_panels_number: 464,
			inverters_number: 3,
			description: `Za Eko Pak iz Surdulice smo izgradili solarnu elektranu sa 190 kWp snažnim sistemom, Luxor 410 Wp solarnim panelima i Huawei inverterima! Saznajte više!`,
			expected_production: 228_000,
			gallery: [ref30_1, ref30_2, ref30_3],
			slug: "solarna-elektrana-od-190kWp",
			content: "",
		},
		{
			id: 31,
			path: "blog",
			blt_id: 1,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumb-logo.png`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Budimgrad 420 KWP",
			titleTop: "420 kWp - BUDIMGRAD",
			location: "Budilovina",
			solar_panels: "Luxor 450 Wp",
			inverters: "Huawei",
			system_power: "420 kWp",
			batteries: "",
			solar_panels_number: 934,
			inverters_number: 6,
			description: `Za Budimgrad iz Budilovine smo izgradili solarnu elektranu sa 420 kWp snažnim sistemom, Luxor 450 Wp solarnim panelima i Huawei inverterima. Saznajte više!`,
			expected_production: 504_000,
			gallery: [ref31_1, ref31_2, ref31_3, ref31_4, ref31_5],
			slug: "solarna-elektrana-od-420kwp-budimgrad",
			content: "",
		},
		{
			id: 32,
			path: "blog",
			blt_id: 1,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb32.png`,
			cover: cover1,
			pageTitle: "Solarna Elektrana JR Tempo Foods 155 KWP",
			titleTop: "155 kWp - JR TEMPO FOODS",
			location: "Trstenik",
			solar_panels: "Luxor 450 Wp",
			inverters: "Huawei",
			system_power: "155 kWp",
			batteries: "",
			solar_panels_number: 348,
			inverters_number: 3,
			description: `Za JR Tempo Foods iz Trstenika smo izgradili solarnu elektranu sa 155 kWp sistemom, Luxor 450 Wp solarnim panelima i Huawei inverterima! Saznajte više!`,
			expected_production: 186_000,
			gallery: [ref32_1, ref32_2, ref32_3, ref32_4, ref32_5],
			slug: "solarna-elektrana-od-155kWp",
			content: "",
		},
		{
			id: 33,
			path: "blog",
			blt_id: 1,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb33.png`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Feroplast 66 KWP",
			titleTop: "66 kWp - FEROPLAST",
			location: "Vrčin",
			solar_panels: "Luxor 410 Wp",
			inverters: "Huawei",
			system_power: "66 kWp",
			batteries: "",
			solar_panels_number: 147,
			inverters_number: 1,
			description: `Za Feroplast iz Vrčina smo izgradili solarnu elektranu sa 66 kWp snažnim sistemom, Luxor 410 Wp solarnim panelima i Huawei inverterima! Saznajte više!`,
			expected_production: 79_200,
			gallery: [ref33_1, ref33_2, ref33_3, ref33_4],
			slug: "solarna-elektrana-od-66kWp-feroplast",
			content: "",
		},
		{
			id: 34,
			path: "blog",
			blt_id: 2,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb34.jpg`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Palić, Subotica 2.7 KWP",
			titleTop: "Solarni mrežni sistem",
			titleBottom: "2.7 kWp - Palić",
			location: "Subotica",
			solar_panels: "Luxor 270 W",
			inverters: "Solax",
			system_power: "2.7 kWp",
			batteries: "",
			solar_panels_number: 10,
			inverters_number: 1,
			description: `Treba vam solarni mrežni sistem na Paliću? Pogledajte solarnu elektranu sa 2,7 kWp sistemom i Luxor 270W solarnim panelima koju smo tamo izgradili!`,
			expected_production: 3240,
			gallery: [ref34_1, ref34_2],
			slug: "Solarni-mrezni-sistem-2-7-KWp",
			content: "",
		},
		{
			id: 35,
			path: "blog",
			blt_id: 2,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb35.jpg`,
			cover: cover1,
			pageTitle: "Hibridni Solarni Sistemi Kać 5 KWP",
			titleTop: "Hibridni solarni sistem",
			titleBottom: "5 kWp - Kać",
			location: "Kać",
			solar_panels: "Luxor 330W",
			inverters: "Imeon",
			system_power: "5 kWp",
			batteries: "Newmax",
			solar_panels_number: 15,
			inverters_number: 1,
			description: `Trebaju vam hibridni solarni sistemi? Izgradili smo hibridni solarni sistem u Kaću od 5kWp snage, sa Luxor 300W solarnim panelima i Imeon inverterima!`,
			expected_production: 6000,
			gallery: [ref35_1, ref35_2, ref35_3],
			slug: "Hibridni-solarni-sistem-5kw",
			content: "",
		},
		{
			id: 36,
			path: "blog",
			blt_id: 2,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb36.jpg`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Petrovac na Mlavi 6 KWP",
			titleTop: "Solarni mrežni sistem",
			titleBottom: "6 kWp - Petrovac na Mlavi",
			location: "Petrovac na Mlavi",
			solar_panels: "Solar Fabrik 340W",
			inverters: "Fronius",
			system_power: "6 kWp",
			batteries: "",
			solar_panels_number: 18,
			inverters_number: 1,
			description: `Treba vam solarni mrežni sistem u Petrovcu na Mlavi? Pogledajte solarnu elektranu sa 6kWp snažnim sistemom i Solar Fabrik panelima koju smo tamo izgradili!`,
			expected_production: 7200,
			gallery: [ref36_1, ref36_2],
			slug: "Solarni-mrezni-sistem-6-Kwp",
			content: "",
		},
		{
			id: 37,
			path: "blog",
			blt_id: 2,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb37.jpg`,
			cover: cover1,
			pageTitle: "Hibridni Solarni Sistemi Loznica 5 KWP",
			titleTop: "Hibridni solarni sistem",
			titleBottom: "5 kWp - Loznica",
			location: "Loznica",
			solar_panels: "Solar Fabrik 340W",
			inverters: "Imeon",
			system_power: "5 kWp",
			batteries: "Newmax",
			solar_panels_number: 15,
			inverters_number: 1,
			description: `Trebaju vam hibridni solarni sistemi? Izgradili smo hibridni solarni sistem u Loznici sa 5kWp snažnim sistemom i Solar Fabrik 340W solarnim panelima!`,
			expected_production: 6000,
			gallery: [ref37_1],
			slug: "Hibridni-solarni-sistem-5kw-loznica",
			content: "",
		},
		{
			id: 38,
			path: "blog",
			blt_id: 2,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb38.jpg`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Bajina Bašta 20 KWP",
			titleTop: "Solarni mrežni sistem",
			titleBottom: "20 kWp - Bajina Bašta",
			location: "Bajina Bašta",
			solar_panels: "Luxor 270W",
			inverters: "Fronius",
			system_power: "20 kWp",
			batteries: "",
			solar_panels_number: 76,
			inverters_number: 1,
			description: `Treba vam solarni mrežni sistem u Bajinoj Bašti? Pogledajte solarnu elektranu sa 20 kWp sistemom i Luxor 270 W solarnim panelima koju smo tamo izgradili!`,
			expected_production: 24_000,
			gallery: [ref38_1, ref38_2, ref38_3],
			slug: "Solarna-Elektrana-20-KWp",
			content: "",
		},
		{
			id: 39,
			path: "blog",
			blt_id: 2,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb39.jpg`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Pančevo 5 KWP",
			titleTop: "Solarni mrežni sistem",
			titleBottom: "5kWp - Pančevo",
			location: "Pančevo/Beograd",
			solar_panels: "Solar Fabrik 340W",
			inverters: "Fronius",
			system_power: "5 kWp",
			batteries: "",
			solar_panels_number: 15,
			inverters_number: 1,
			description: `Treba vam solarni mrežni sistem u Pančevu? Pogledajte solarnu elektranu sa 5 kWp sistemom i Solar Fabrik 340 W solarnim panelima koju smo tamo izgradili!`,
			expected_production: 6000,
			gallery: [ref39_1, ref39_2],
			slug: "solarni-mrezni-sistem-5-kwp-pancevo-beograd",
			content: "",
		},
		{
			id: 40,
			path: "blog",
			blt_id: 2,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb40.jpg`,
			cover: cover1,
			pageTitle: "Solarni mrežni sistem 5 kWp - Bukovica, Ivanjica",
			titleTop: "Solarni mrežni sistem",
			titleBottom: "5 kWp - Bukovica, Ivanjica",
			location: "Bukovica, Ivanjica",
			solar_panels: "Solar Fabrik 280W",
			inverters: "Fronius",
			system_power: "5 kWp",
			batteries: "",
			solar_panels_number: 18,
			inverters_number: 1,
			description: `Treba vam solarni mrežni sistem u gradu Bukovica, Ivanjica? Pogledajte solarnu elektranu od 5 kWp sa Solar Fabrik 280 W panelima koju smo tamo instalirali!`,
			expected_production: 6000,
			gallery: [ref40_1, ref40_2],
			slug: "Solarni-mrezni-sistem-5-Kwp",
			content: "",
		},
		{
			id: 41,
			path: "blog",
			blt_id: 2,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb41.jpg`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Padina 10 KWP",
			titleTop: "Solarni mrežni sistem",
			titleBottom: "10 kWp - Padina",
			solar_panels: "Solar Fabrik 280W",
			inverters: "Fronius",
			system_power: "10 kWp",
			batteries: "",
			location: "Padina",
			solar_panels_number: 18,
			inverters_number: 1,
			description: `Treba vam solarni mrežni sistem u Padini? Pogledajte solarnu elektranu sa 10 kWp sistemom i Solar Fabrik 280 W solarnim panelima koju smo tamo izgradili!`,
			expected_production: 12_000,
			gallery: [ref41_1],
			slug: "Solarni-mrezni-sistem-10-Kwp-Padina",
			content: "",
		},
		{
			id: 42,
			path: "blog",
			blt_id: 2,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb42.jpg`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Obrež 5 KWP",
			titleTop: "Solarni mrežni sistem",
			titleBottom: "5 kWp - Obrež",
			solar_panels: "Solar Fabrik 340W",
			inverters: "Fronius",
			system_power: "5 kWp",
			batteries: "",
			location: "Obrež",
			solar_panels_number: 15,
			inverters_number: 1,
			description: `Treba vam solarni mrežni sistem u Obrežu? Pogledajte solarnu elektranu od 5 kWp sa preusmeravanjem viška energije ka bojleru koju smo tamo izgradili!`,
			expected_production: 6000,
			gallery: [ref42_1, ref42_2],
			slug: "solarni-mrezni-sistem-sa-preusmeravanjem-viska-energije-ka-bojleru-5-kwp",
			content: "",
		},
		{
			id: 43,
			path: "blog",
			blt_id: 2,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb43.jpg`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Kladovo 2.8 KWP",
			titleTop: "Solarni mrežni sistem",
			titleBottom: "2.8 kWp - Kladovo",
			location: "Kladovo",
			solar_panels: "Luxor 275W",
			inverters: "Solax",
			system_power: "2.8 kWp",
			batteries: "",
			solar_panels_number: 18,
			inverters_number: 1,
			description: `Treba vam solarni mrežni sistem u Kladovu? Pogledajte solarnu elektranu sa 2,8 kWp snažnim sistemom i Luxor 275W solarnim panelima koju smo tamo izgradili!`,
			expected_production: 3360,
			gallery: [ref43_1, ref43_2],
			slug: "Solarni-mrezni-sistem-2-8-Kwp",
			content: "",
		},
		{
			id: 44,
			path: "blog",
			blt_id: 2,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb44.jpg`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Padina 5 KWP",
			titleTop: "Solarni mrežni sistem",
			titleBottom: "5 kWp - Padina",
			location: "Padina",
			solar_panels: "Solar Fabrik 280W",
			inverters: "Fronius",
			system_power: "5 kWp",
			batteries: "",
			solar_panels_number: 18,
			inverters_number: 1,
			description: `Treba vam solarni mrežni sistem u Padini? Pogledajte solarnu elektranu sa 5 kWp sistemom i Solar Fabrik 280 w solarnim panelima koju smo tamo izgradili!`,
			expected_production: 6000,
			gallery: [ref44_1],
			slug: "Solarni-mrezni-sistem-5-Kwp-Padina",
			content: "",
		},
		{
			id: 45,
			path: "blog",
			blt_id: 2,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb45.jpg`,
			cover: cover1,
			pageTitle: "Solarni Litijumski Sistem Beograd 5.8 KWP",
			titleTop: "Hibridni solarni sistem",
			titleBottom: "5.8 kWp - Beograd",
			location: "Beograd",
			solar_panels: "Solar Fabrik 280W",
			inverters: "Fronius",
			system_power: "5.8 kWp",
			batteries: "BYD litijumska baterija",
			solar_panels_number: 16,
			inverters_number: 1,
			description: `Treba vam solarni litijumski sistem u Beogradu? Pogledajte hibridni solarni sistem sa 5,8 kWp i Solar Fabrik 280 W solarnim panelima koji smo izgradili!`,
			expected_production: 6960,
			gallery: [ref45_1],
			slug: "Solarni-litijumski-sistem-5-8-kwp",
			content: "",
		},
		{
			id: 46,
			path: "blog",
			blt_id: 2,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb46.jpg`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Beograd 3.4 KWP",
			titleTop: "Solarni mrežni sistem",
			titleBottom: "3.4 kWp - Beograd",
			location: "Beograd",
			solar_panels: "Solar Fabrik 340W",
			inverters: "Fronius",
			system_power: "3.4 kWp",
			batteries: "",
			solar_panels_number: 10,
			inverters_number: 1,
			description: `Treba vam solarni mrežni sistem u Beogradu? Pogledajte solarnu elektranu sa 3,4 kWp sistemom i Solar Fabrik 340W solarnim panelima koju smo tamo izgradili!`,
			expected_production: 4080,
			gallery: [ref46_1, ref46_2],
			slug: "Solarni-mrezni-sistem-3-Kwp-Beograd",
			content: "",
		},
		{
			id: 47,
			path: "blog",
			blt_id: 2,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb47.jpg`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Jakovo 5 KWP",
			titleTop: "Solarni mrežni sistem",
			titleBottom: "5 kWp - Jakovo",
			location: "Jakovo",
			solar_panels: "Solar Fabrik 340W",
			inverters: "Fronius",
			system_power: "5 kWp",
			batteries: "",
			solar_panels_number: 15,
			inverters_number: 1,
			description: `Treba vam solarni mrežni sistem u Jakovu? Pogledajte solarnu elektranu sa 5 kWp sistemom i Solar Fabrik 340W solarnim panelima koju smo tamo izgradili!`,
			expected_production: 6000,
			gallery: [ref47_1, ref47_2],
			slug: "Solarni-mrezni-sistem-5-Kwp-Jakovo",
			content: "",
		},
		{
			id: 49,
			path: "reference",
			blt_id: 1,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb23.svg`,
			cover: cover1,
			pageTitle: "Solarna Elektrana za Radun Avia Pumpu 36 KWP",
			titleTop: "36 kWp - RADUN AVIA",
			location: "Kanjiža",
			solar_panels: "Phono Solar 460 W",
			inverters: "Huawei",
			system_power: "36 kWp",
			batteries: "",
			solar_panels_number: 78,
			inverters_number: 1,
			description:
				"Za Radun Avia benzinsku pumpu u Kanjiži smo izgradili solarnu elektranu sa 36 kWp snažnim sistemom i Phono Solar 460 W solarnim panelima. Saznajte više!",
			expected_production: 43_200,
			gallery: [ref49_1, ref49_2],
			slug: "radun-avia-kanjiza",
			content: "",
		},
		{
			id: 50,
			path: "reference",
			blt_id: 1,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb50.jpg`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Bulić 24.5 KWP",
			titleTop: "24.5 kWp - BULIĆ",
			location: "Nova Pazova",
			solar_panels: "Phono Solar 460 W",
			inverters: "Huawei",
			system_power: "24.5 kWp",
			batteries: "",
			solar_panels_number: 54,
			inverters_number: 1,
			description:
				"Za Bulić CO iz Nove Pazove smo izgradili solarnu elektranu sa 24,5 kWp sistemom, Phono Solar 460 W solarnim panelima i Huawei inverterima! Saznajte više!",
			expected_production: 29_400,
			gallery: [ref50_1],
			slug: "bulic-nova-pazova",
			content: "",
		},
		{
			id: 51,
			path: "reference",
			blt_id: 1,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb51.png`,
			cover: cover1,
			pageTitle: "Solarna Elektrana za Ševo Tim DOO Umka 147.2 KWP",
			titleTop: "147.2 kWp - ŠEVO TIM D.O.O",
			location: "Umka",
			solar_panels: "Phono Solar 460 W",
			inverters: "Huawei",
			system_power: "147.2 kWp",
			batteries: "",
			solar_panels_number: 320,
			inverters_number: 4,
			description:
				"Za Ševo Tim D.O.O. iz Umke smo izgradili solarnu elektranu sa 147,2 kWp snažnim sistemom i Phono Solar 460 W solarnim panelima i Huawei inverterima!",
			expected_production: 176_640,
			gallery: [ref51_1, ref51_2],
			slug: "sevo-tim-umka",
			content: "",
		},
		{
			id: 52,
			path: "reference",
			blt_id: 1,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb52.webp`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Mara Kore D.O.O. 194 KWP",
			titleTop: "194 kWp - MARA KORE D.O.O",
			location: "Sombor",
			solar_panels: "Phono Solar 460 W",
			inverters: "Huawei",
			system_power: "194 kWp",
			batteries: "",
			solar_panels_number: 421,
			inverters_number: 4,
			description:
				"Za Mara Kore DOO iz Sombora smo izgradili solarnu elektranu sa 194 kWp sistemom, Phono Solar 460 W solarnim panelima i Huawei inverterima! Saznajte više!",
			expected_production: 232_800,
			gallery: [ref52_1, ref52_2, ref52_3],
			slug: "mara-kore",
			content: "",
		},
		{
			id: 53,
			path: "reference",
			blt_id: 1,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb48.png`,
			cover: cover1,
			pageTitle: "Solarna Elektrana za Apatinsku Pivaru 98.8 KWP",
			titleTop: "98.8 kWp - APATINSKA PIVARA",
			location: "Apatin",
			solar_panels: "Phono Solar 460 W",
			inverters: "Huawei",
			system_power: "98.8 kWp",
			batteries: "",
			solar_panels_number: 214,
			inverters_number: 3,
			description:
				"Za otpadne vode u Apatinskoj Pivari smo izgradili solarnu eletkranu sa 98,8 kWp snažnim sistemom, Phono Solar 460 W solarnim panelima i Hauwei inverterima!",
			expected_production: 118_560,
			// gallery: [ref53_1, ref53_2, ref53_3],
			gallery: [ref53_1, ref9_2, ref53_3],
			slug: "otpadne-vode-apatin",
			content: "",
		},
		{
			id: 23,
			path: "blog",
			blt_id: 1,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb23.svg`,
			cover: cover1,
			pageTitle: "Solarna Elektrana za Radun Avia pumpu 60 KWP",
			titleTop: "60 kWp - RADUN AVIA",
			location: "Novi Sad",
			solar_panels: "Canadian 445 Wp",
			inverters: "Huawei",
			system_power: "60 kWp",
			batteries: "",
			solar_panels_number: 150,
			inverters_number: 2,
			description: `Za Radun Avia benzinsku pumpu u Novom Sadu smo izgradili solarnu elektranu sa 60 kWp snažnim sistemom i Canadian 445 Wp solarnim panelima. Saznajte više!`,
			expected_production: 72_000,
			gallery: [ref23_1, ref23_2, ref23_3],
			slug: "solarna-elektrana-od-60kWp-radunavia",
			content: "",
		},
		{
			id: 19,
			path: "blog",
			blt_id: 1,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb19.png`,
			cover: cover1,
			pageTitle: "Solarna Elektrana za Desing D.O.O. 672 KWP",
			titleTop: "672 kWp - DESING",
			location: "Knjaževac",
			solar_panels: "Luxor 455 Wp",
			inverters: "Huawei",
			system_power: "672 kWp",
			batteries: "",
			solar_panels_number: 1494,
			inverters_number: 37,
			description: `Za Desing DOO iz Knjaževca smo izgradili solarnu elektranu sa 672 kWp snažnim sistemom, Luxor 455 Wp solarnim panelima i Huawei inverterima. Saznajte više!`,
			expected_production: 806_400,
			gallery: [ref19_1, ref19_2, ref19_3, ref19_4],
			slug: "solarna-elektrana-od-672kWp",
			content: "",
		},
		{
			id: 14,
			path: "blog",
			blt_id: 1,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb14.png`,
			cover: cover1,
			pageTitle: "Solarna Elektrana za Vahali Brodogradilište",
			titleTop: "1052 kWp - VAHALI",
			location: "Sremska Mitrovica",
			solar_panels: "Luxor 375 Wp",
			inverters: "Huawei",
			system_power: "1052 kWp",
			batteries: "",
			solar_panels_number: 2807,
			inverters_number: 9,
			description: `Za Vahali Brodogradilište iz Sremske Mitrovice smo izgradili solarnu elektranu sa 1052 kWp snažnim sistemom i Luxor 375Wp solarnim panelima. Saznajte više!`,
			expected_production: 1_262_400,
			gallery: [ref14_1, ref14_2, ref14_3],
			// slug: "Solarna-elektrana-1052 kWp-Vahali-Brodogradiliste-Sremska%20Mitrovica",
			slug: "solarna-elektrana-1052-kwp-vahali-brodogradiliste-sremska-mitrovica",
			content: "",
		},
		{
			id: 12,
			path: "blog",
			blt_id: 1,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb12.png`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Rudnik i Flotacija DOO 462 KWP",
			titleTop: "462 kWp - RUDNIK FLOTACIJA",
			location: "Rudnik",
			solar_panels: "Luxor 455 Wp",
			inverters: "Huawei",
			system_power: "",
			batteries: "",
			solar_panels_number: 929,
			inverters_number: 13,
			description: `Za Rudnik i Flotacija D.O.O iz mesta Rudnik smo izgradili solarnu elektranu sa 462 kWp snažnim sistemom i Luxor 455 Wp solarnim panelima. Saznajte više!`,
			expected_production: 554_400,
			gallery: [ref12_1, ref12_2, ref12_3, ref12_4],
			slug: "solarna-elektrana-od-462kwp",
			content: "",
		},
		{
			id: 8,
			path: "blog",
			blt_id: 1,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb8.png`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Moka Čačak D.O.O 400 KWP",
			titleTop: "400 kWp - MOKA ČAČAK",
			location: "Čačak",
			solar_panels: "Luxor 370 Wp",
			inverters: "Huawei",
			system_power: "",
			batteries: "",
			solar_panels_number: 1081,
			inverters_number: 6,
			description: `Za Moka DOO iz Čačka smo izgradili solarnu elektranu sa 400 kWp snažnim sistemom, Luxor 370 Wp solarnim panelima i Hauwei inverterima. Saznajte više!`,
			expected_production: 480_000,
			gallery: [ref8_1],
			slug: "solarna-elektrana-400-kwp-moka-cacak-doo",
			content: "",
		},
		{
			id: 48,
			path: "reference",
			blt_id: 1,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb48.png`,
			cover: cover1,
			pageTitle: "Solarna Elektrana za Apatinsku Pivaru 1000 KWP",
			titleTop: "1000 kWp - APATINSKA PIVARA",
			location: "Apatin",
			solar_panels: "Phono Solar 460 W",
			inverters: "Huawei",
			system_power: "1000 kWp",
			batteries: "",
			solar_panels_number: 2174,
			inverters_number: 9,
			description:
				"Za Apatinsku Pivaru iz Apatina smo na krovu izgradili solarnu elektranu sa 100 kWp snažnim sistemom i Phono Solar 460 W solarnim panelima. Saznajte više!",
			expected_production: 1_200_000,
			gallery: [ref48_1, ref48_2, ref48_3],
			slug: "apatinska-pivara",
			content: "",
		},
		{
			id: 55,
			path: "blog",
			blt_id: 2,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb55.jpg`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Kragujevac 6 KWP",
			titleTop: "Solarni mrežni sistem",
			titleBottom: "6 kWp - Kragujevac",
			location: "Kragujevac",
			solar_panels: "Phono solar 460 W",
			inverters: "Huawei",
			system_power: "6 kWp",
			batteries: "",
			solar_panels_number: 13,
			inverters_number: 1,
			description: `Treba vam solarni mrežni sistem u Kragujevcu? Pogledajte solarnu elektranu sa 6 kWp snagom sistema i Phono solar 460W solarnim panelima koju smo izgradili!`,
			expected_production: 7000,
			gallery: [ref55_1, ref55_2],
			slug: "solarna-elektrana-od-6kwp-kragujevac",
			content: "",
		},
		{
			id: 56,
			path: "blog",
			blt_id: 2,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb56.jpg`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Mirjevo 10 KWP",
			titleTop: "Solarni mrežni sistem",
			titleBottom: "10 kWp - Mirijevo",
			location: "Mirijevo",
			solar_panels: "Phono solar 460 W",
			inverters: "Huawei",
			system_power: "10 kWp",
			batteries: "",
			solar_panels_number: 22,
			inverters_number: 1,
			description: `Treba vam solarni mrežni sistem u Mirjevu? Pogledajte solarnu elektranu od 10 kWp sa Phono solar 460 W solarnim panelima koju smo instalirali u Mirjevu!`,
			expected_production: 12_000,
			gallery: [ref56_1, ref56_2],
			slug: "solarna-elektrana-od-10kwp-mirijevo-beograd",
			content: "",
		},
		{
			id: 57,
			path: "blog",
			blt_id: 2,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb57.jpg`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Ram, Veliko Gradište 12 KWP",
			titleTop: "Solarni mrežni sistem",
			titleBottom: "12 kWp - Ram",
			location: "RAM",
			solar_panels: "Phono solar 460 W",
			inverters: "Huawei",
			system_power: "12 kWp",
			batteries: "",
			solar_panels_number: 26,
			inverters_number: 1,
			description: `Treba vam solarni mrežni sistem u mestu Ram? Pogledajte solarnu elektranu sa 12 kWp snagom sistema i Phono solar 460 W panelima koju smo tamo izgradili!`,
			expected_production: 13_000,
			gallery: [ref57_1],
			slug: "solarna-elektrana-od-12kwp-ram",
			content: "",
		},
		{
			id: 58,
			path: "reference",
			blt_id: 2,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb58.jpg`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Šabac 13 KWP",
			titleTop: "Solarni mrežni sistem",
			titleBottom: "13 kWp - Šabac",
			location: "Šabac",
			solar_panels: "Luxor 540 W",
			inverters: "Huawei",
			system_power: "13 kWp",
			batteries: "",
			solar_panels_number: null,
			inverters_number: null,
			description:
				"Treba vam solarni mrežni sistem u Šapcu? Pogledajte solarnu elektranu sa 13 kWp snažnim sistemom i Luxor 540 W solarnim panelima koju smo tamo izgradili!",
			expected_production: null,
			gallery: [ref58_1, ref58_2, ref58_3],
			slug: "solarni-mrezni-sistem-13kWp-sabac",
			content: "",
		},
		{
			id: 59,
			path: "reference",
			blt_id: 2,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb59.jpg`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Vinorača, Jagodina 6.9 KWP",
			titleTop: "Solarni mrežni sistem",
			titleBottom: "6.9 kWp - Vinorača, Jagodina",
			location: "Vinorača, Jagodina",
			solar_panels: "Phono solar 460 W",
			inverters: "Huawei",
			system_power: "6.9 kWp",
			batteries: "",
			solar_panels_number: null,
			inverters_number: null,
			expected_production: null,
			gallery: [ref59_1, ref59_2],
			slug: "solarni-mrežni-sistem-6-9kWp-Vinorača-Jagodina",
			content: "",
			description:
				"Treba vam solarni mrežni sistem u Vinorači kod Jagodine? Pogledajte solarnu elektranu sa 6,9 kWp snagom sistema i Luxor panelima koju smo tamo izgradili!",
		},
		{
			id: 60,
			path: "reference",
			blt_id: 2,
			thumb: `${store.BASE_URL}/assets_suncica/references/thumbs/thumb60.jpg`,
			cover: cover1,
			pageTitle: "Solarna Elektrana Grocka 10 KWP",
			titleTop: "Solarni mrežni sistem",
			titleBottom: "10 kWp - Grocka",
			location: "Grocka",
			solar_panels: "Luxor 440",
			inverters: "Huawei",
			system_power: "10 kWp",
			batteries: "",
			solar_panels_number: null,
			inverters_number: null,
			expected_production: null,
			gallery: [ref60_1, ref60_2],
			slug: "solarni-mrezni-sistem-10kWp-grocka",
			content: "",
			description:
				"Treba vam solarni mrežni sistem u Grockoj? Pogledajte solarnu elektranu sa 10 kWp snagom sistema i Luxor 440 solarnim panelima koju smo tamo izgradili!",
		},
	];

	const testimonialsListLegal = [
		{
			id: 1,
			section: 1,
			text: $t("app.legalTestimonials.section1"),
			video: testimonial_1,
			description: `Pogledajte impresivnu solarnu elektranu snage 1000 kWp koju je Sunčica Solar instalirala u <span class="testimonial-bold">Apatinskoj pivari</span>, jednom od vodećih proizvođača piva u Srbiji.`,
		},
		{
			id: 2,
			section: 1,
			text: $t("app.legalTestimonials.section2"),
			video: testimonial_2,
			description: `Mi smo BUDIM GRAD DOO, porodična firma osnovana 1992 godine i bavimo se otkupom, preradom i zamrzavanjem voća. Nalazimo se u centralnoj Srbiji, u selu Budilovina, u blizini grada Brus.
		
			
Glavni razlog za montažu solarne elektrane na krovu naše firme je potreba za energetskom nezavisnošću koja nam pruža veću nezavisnost od fluktuacije cene energije na tržištu.
			`,
		},
		{
			id: 3,
			section: 1,
			text: $t("app.legalTestimonials.section3"),
			video: testimonial_3,
			description: `Naša firma, <span class="testimonial-bold">MOKA iz Čačka</span>, imala je izuzetno pozitivna iskustva sa instalacijom i korišćenjem solarnih panela. Odluka da se okrenemo obnovljivim izvorima energije pokazala se kao jedan od najboljih poslovnih poteza koje smo napravili. Evo nekoliko razloga:
			
			
<span class="testimonial-underline">Značajne Finansijske Uštede:</span>
Od trenutka kada su solarni paneli pušteni u rad, osetno su manji računi za električnu energiju. Ove uštede su nam omogućile da se odlučimo za dodatno proširenje kapaciteta solarne elektrane u narednom periodu.`,
		},
		{
			id: 3,
			section: 2,
			text: $t("app.legalTestimonials.section4"),
			video: testimonial_4,
			description: "",
		},
	];

	const testimonialsListRegular = [
		{
			id: 1,
			section: 1,
			text: $t("app.legalTestimonials.section5"),
			video: testimonial_5,
			description: `<span class="testimonial-bold">Ivan Petrović iz Zemuna</span>


Ideja za solarne panela mi se javila pre desetak  godina jer sam hteo da budem energetski nezavistan kao i da smanjim troškove odnosno racune za struju koji su bili visoki. Prilikom izgradnje novog krova na kuci odlucio sam se da je trenutak za postavljanje panela. Kontaktirao sam firmu iz Beograda, SUNČICA DOO gde sam dobio odgovor na svako moje pitanje.`,
		},
		{
			id: 2,
			section: 1,
			text: $t("app.legalTestimonials.section6"),
			video: testimonial_6,
			description: `<span class="testimonial-bold">Marko Vukumirović iz Subotice</span>


<p>Jedan od glavnih razloga zašto sam se odlučio za solarnu elektranu je značajno smanjenje mesečnih troškova za električnu energiju. Kao prosumer, sada proizvodim vlastitu energiju, što mi omogućava da smanjim račune za struju i uštedim novac.</p>`,
		},
	];

	return {
		referencesList,
		testimonialsListLegal,
		testimonialsListRegular,
	};
});
